import React from "react";
import styled from "styled-components";

import bar from "../assets/bar.png";
import building from "../assets/building.png";
import bear from "../assets/bear.png";
import tshirt from "../assets/tshirt.png";
import controller from "../assets/controller.png";
import paw from "../assets/paw.png";
import brew from "../assets/brew.png";
import trophy from "../assets/trophy.png";

const FlexContainer = styled.div`
  width: 50%;
  display: flex;

  @media (min-width: 1281px) {
    justify-content: center;
  }

  @media (min-width: 1025px) and (max-width: 1440px) {
    width: 45%;
    margin-left: 5%;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    justify-content: end;
  }
`;

const StatsBox = styled.div`
  background: white;
  margin-bottom: auto;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  border-radius: 0.5em;

  @media (min-width: 1441px) {
    max-width: 60%;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    max-width: 90%;
  }
`;

const Stat = styled.div`
  display: flex;
  padding: 1em 2em;
  align-items: center;

  > img {
    width: 20%;
    max-width: 12.5%;
    margin-right: 1em;
  }

  div {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    span {
      margin-left: auto;
      margin-bottom: 0.5em;
      padding: 0.5em 1em;
      background: #673c8c;
      color: #fff;
      font-weight: bold;
      font-size: 1.5em;
      border-radius: 5%;
      min-width: 35px;
      text-align: center;
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      span {
        padding: 0.25em 0.75em;
      }

      img {
        width: 100%;
      }
    }
  }
`;

export default function EmileStats() {
  return (
    <FlexContainer>
      <StatsBox>
        <Stat>
          <img src={building} alt="building-icon" />
          <div>
            <span>? / 4</span>
            <img src={bar} alt="bar" />
          </div>
        </Stat>
        <Stat>
          <img src={bear} alt="bear-icon" />
          <div>
            <span>? / 11</span>
            <img src={bar} alt="bar" />
          </div>
        </Stat>
        <Stat>
          <img src={tshirt} alt="tshirt-icon" />
          <div>
            <span>? / 151</span>
            <img src={bar} alt="bar" />
          </div>
        </Stat>
        <Stat>
          <img src={controller} alt="controller-icon" />
          <div>
            <span>? / 2</span>
            <img src={bar} alt="bar" />
          </div>
        </Stat>
        <Stat>
          <img src={paw} alt="paw-icon" />
          <div>
            <span>? / 10</span>
            <img src={bar} alt="bar" />
          </div>
        </Stat>
        <Stat>
          <img src={brew} alt="brew-icon" />
          <div>
            <span>? / 12</span>
            <img src={bar} alt="bar" />
          </div>
        </Stat>
        <Stat>
          <img src={trophy} alt="trophy-icon" />
          <div>
            <span>? / 11</span>
            <img src={bar} alt="bar" />
          </div>
        </Stat>
      </StatsBox>
    </FlexContainer>
  );
}
